<template>
  <b-container fluid class="p-0 mb-5">
    <b-alert show variant="warning" class="d-flex justify-content-between align-items-center mb-0 w-100">
      <div class="d-flex align-items-center">
        <component :is="getLucideIcon('AlertTriangle')" :size="30" class="mr-2" />
        <span class="font-weight-bold font-sm"> This option is only for experimental development mode. Be sure it is not used or shown on production. </span>
      </div>
      <b-button class="text-nowrap" variant="outline-dark" size="sm" @click="$emit('clicked')"> Fill Form </b-button>
    </b-alert>
  </b-container>
</template>

<script>
import globalMixin from '@/mixins/global.mixin';

export default {
  name: 'AutoFillJobRequestButton',
  mixins: [globalMixin]
};
</script>
